export default class VariableClassModel {

    idNTipoVariable : number | null;
    fkNTipoElemento: number | null;
    fkNTipoVariableOMRON: number | null;
    fkNAgrupacionVariable: number | null;
    fkNTipoVariableWEB: number | null;
    fldTNombre: string | null;
    fldTDireccionDM: string | null;
    fldBVisibleEnPortada: boolean | null;
    fkNIcono: number | null;
    fldNOrden: number | null;
    fldTStyle: string | null;
    fldBLectura: boolean | null;
    fldBEscritura: boolean | null;
    fldBGraficable: boolean | null;
    fldBComboTipoVariable: boolean | null;
    fldTDireccionVariable: string | null;

    constructor() {
        this.idNTipoVariable = null;
        this.fkNTipoElemento = null;
        this.fkNTipoVariableOMRON = null;
        this.fkNAgrupacionVariable = null;
        this.fkNTipoVariableWEB = null;
        this.fldTNombre = null;
        this.fldTDireccionDM = null;
        this.fldBVisibleEnPortada = null;
        this.fkNIcono = null;
        this.fldNOrden = null;
        this.fldTStyle = null;
        this.fldBLectura = null;
        this.fldBEscritura = null;
        this.fldBGraficable = null;
        this.fldBComboTipoVariable = null;
        this.fldTDireccionVariable = null;
    }
}